var map = {
	"./FENCE.png": 36,
	"./JAEGER.png": 452,
	"./LIGHTKEEPER.png": 5498,
	"./MECHANIC.png": 7759,
	"./PEACEKEEPER.png": 7462,
	"./PRAPOR.png": 262,
	"./RAGMAN.png": 2249,
	"./REF.png": 9046,
	"./SKIER.png": 1426,
	"./THERAPIST.png": 230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2984;